export default "__VITE_PUBLIC_ASSET__f6b7684c__"